import {
  OPEN_SHOP_MODAL,
  CLOSE_SHOP_MODAL,
  OPEN_ADD_TO_CART_MODAL,
  CLOSE_ADD_TO_CART_MODAL,
} from './types';

export default function shopUiReducer(
  state = {
    // Shop EDD/BOPIS Dialog property
    isModalOpen: false,
    // AtC modal properties
    isAddToCartModalOpen: false,
    itemId: '',
    productId: '',
  },
  action = {},
) {
  switch (action.type) {
    case OPEN_SHOP_MODAL:
      return {
        ...state,
        ...action?.payload,
        isModalOpen: true,
      };
    case CLOSE_SHOP_MODAL:
      return {
        ...state,
        ...action?.payload,
        isModalOpen: false,
      };
    case OPEN_ADD_TO_CART_MODAL:
      return {
        ...state,
        ...action?.payload,
        isAddToCartModalOpen: true,
      };
    case CLOSE_ADD_TO_CART_MODAL:
      return {
        ...state,
        ...action?.payload,
        isAddToCartModalOpen: false,
      };

    default:
      return state;
  }
}
